import encodeFormUrl from '../utils/encodeFormUrl';

/**
 * @param {string} formPath/accountId/FormGuid
 * @param {object} details
 * @return {boolean} flag to indicate if successfully stored contact details in hubspot
 */
export const hubspotRequest = async (hubspotFormUrl, details) => {
  let success = true;

  const formBody = encodeFormUrl(details);

  try {
    const response = await fetch(hubspotFormUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: formBody,
    });
    if (!response.ok) {
      throw Error();
    }
  } catch (error) {
    success = false;
  }

  return success;
};

/**
 * @param {string} hubspotFormUrl formPath/accountId/FormGuid
 * @param {string} firstname
 * @param {string} lastname
 * @param {string} email
 * @param {string} phone
 * @param {string} address
 * @param {string} city
 * @param {string} postcode
 * @param {string} batteryOnly
 * @param {boolean} solarConsent
 * @param {boolean} batteryConsent
 * @param {string} source
 * @return {boolean} flag to indicate if successfully stored contact details in hubspot
 */
export const registerSolarInterestInHubspot = async (
  hubspotFormUrl,
  firstname,
  lastname,
  email,
  phone,
  address,
  city,
  postcode,
  batteryOnly,
  solarConsent,
  batteryConsent,
  source,
) => {
  const details = {
    firstname,
    lastname,
    email,
    phone,
    address,
    city,
    zip: postcode,
    battery_only: batteryOnly,
    consent_for_data_sharing_with_solar_partner: solarConsent,
    consent_to_share_with_battery_installer: batteryConsent,
    sourceofsolarlead: source || 'web_app',
  };

  return hubspotRequest(hubspotFormUrl, details);
};

/**
 * @param {string} hubspotFormUrl formPath/accountId/FormGuid
 * @param {string} email
 * @param {string} referredBy
 * @return {boolean} flag to indicate if successfully stored contact details in hubspot
 */
export const registerReferralInHubspot = async (
  hubspotFormUrl,
  email,
  referredBy,
) => {
  const details = {
    email,
    referredBy,
  };

  return hubspotRequest(hubspotFormUrl, details);
};

/**
 * @param {string} hubspotFormUrl formPath/accountId/FormGuid
 * @param {string} emailAddress
 * @return {boolean} flag to indicate if successfully stored contact details in hubspot
 */
export const registerContactInHubspot = async (
  hubspotFormUrl,
  emailAddress,
) => {
  const details = {
    email: emailAddress,
  };

  return hubspotRequest(hubspotFormUrl, details);
};
